import {useState , useEffect} from "react";
import { GoDotFill } from "react-icons/go";
import { createStyles } from "@mantine/core";
const StatusBtn = ({status}) => {
    const useStyles = createStyles((theme) => ({
        statusBtn: {
            padding:'0.3rem 1rem',
            width:'fit-content',
            borderRadius:'3rem',
            display:'flex',
            justifyContent:'space-between',
            alignItems:'center',
            gap:'.5rem'
        },
    }));
    const { classes } = useStyles();
    const [dot,setDot] = useState()
    const [bg,setBg] = useState()
    const [color,setColor] = useState('#000')

    useEffect(()=>{
        let lowerStatus = status.toLowerCase()
        console.log("🚀 ~ useEffect ~ lowerStatus:", status)
        if(lowerStatus === "inactive"){
            setDot("#667085")
            setBg("#F2F4F7")
            setColor('#344054')
        }
        else if(lowerStatus === "upcoming"){
            setDot("#7A5AF8")
            setBg("#F4F3FF")
            setColor('#5925DC')
        }
        else if(lowerStatus === "stopped" || lowerStatus === "unpaid"){
            setDot("#F04438")
            setBg("#FEF3F2")
            setColor('#B42318')
        }
        else{
            setDot("#12B76A")
            setBg("#ECFDF3")
            setColor('#027A48')
        }
    },[])
  return (
    <div
      className={classes.statusBtn}
      style={{
        background: bg,
        color:color,
        textTransform: "capitalize",
      }}
    >
      <GoDotFill color={dot} />
      <span>{status || "Active"}</span>
    </div>
  );
};

export default StatusBtn;
